import {Vue} from 'ui.vue';


import './BXmakerAuthuserphoneEnterRegForm.styl';


Vue.component('BXmakerAuthuserphoneEnterRegForm', {
    name: 'BXmakerAuthuserphoneEnterRegForm',
    data() {
        return {};
    },
    computed: {
        birthdayMask(){
            return {
                type: 'imask',
                format: '00.00.0000'
            }
        }
    },
    methods: {

        onEnterFIO(value, item = null) {
            if (value) {
                this.$root.setFIO(value);
                this.$root.setDadataItem(item);
            }
            if (this.$root.isEnabledRegisterBirthday) {
                this.$refs.birthday.focus();
            }
            else
            {
                this.$refs.phone.focus();
            }
        },
        onInputFIO(value) {
            this.$root.setFIO(value);
            this.$root.setDadataItem(null);
        },

        onEnterLastName(value) {
            this.$root.setLastName(value);

            if (this.$root.isEnabledRegisterFirstName) {
                this.$refs.firstName.focus();
            }
            else if (this.$root.isEnabledRegisterSecondName) {
                this.$refs.secondName.focus();
            }
            else if (this.$root.isEnabledRegisterBirthday) {
                this.$refs.birthday.focus();
            }
            else
            {
                this.$refs.phone.focus();
            }
        },
        onInputLastName(value) {
            this.$root.setLastName(value);
        },

        onEnterFirstName(value) {
            this.$root.setFirstName(value);

            if (this.$root.isEnabledRegisterSecondName) {
                this.$refs.secondName.focus();
            }
            else if (this.$root.isEnabledRegisterBirthday) {
                this.$refs.birthday.focus();
            }
            else
            {
                this.$refs.phone.focus();
            }
        },
        onInputFirstName(value) {
            this.$root.setFirstName(value);
        },

        onEnterSecondName(value) {
            this.$root.setSecondName(value);

            if (this.$root.isEnabledRegisterBirthday) {
                this.$refs.birthday.focus();
            }
            else
            {
                this.$refs.phone.focus();
            }
        },
        onInputSecondName(value) {
            this.$root.setSecondName(value);
        },


        onEnterBirthday(value, item = null) {
            if (value) {
                this.$root.setBirthday(value);
            }
            this.$refs.phone.focus();
        },
        onInputBirthday(value){
            value = value.replace(/[^\d.]+/g, '');
            this.$root.setBirthday(value);
        },
        onEnterPhone() {
            if (this.$root.isEnabledRegisterLogin) {
                this.$refs.login.focus();
            } else {
                this.onEnterLogin();
            }
        },
        onChangePhone(data) {
            this.$root.setPhone(data.formattedValue);
        },
        onEnterLogin() {
            if (this.$root.isEnabledRegisterEmail) {
                this.$refs.email.focus();
            } else {
                this.onEnterEmail();
            }
        },
        onEnterEmail() {
            if (this.$root.isEnabledRegisterPassword) {
                this.$refs.password.focus();
            } else {
                this.onEnterPassword();
            }
        },
        onEnterPassword() {
            this.onClickConfirm();
        },
        onClickConfirm() {
            if (this.$root.isEnabledRequestConsent && !this.$root.isConsentReceived) {
                this.$refs.consent.showPopup();
                return;
            }

            if (this.$root.isFullCaptcha) {
                this.$root.register();
            }
        },
        onConsentAgree() {
            this.$root.consentAgree();

            if (this.$root.isFullCaptcha) {
                this.$root.register();
            }
        },

        onChangeAdsAgreement(data){
            this.$root.setAdsAgreement(data.value);
        }
    },
    //language=Vue
    template: `
      <div class="bxmaker-authuserphone-enter-reg-form">

      <slot name="message">
        <BXmakerAuthuserphoneMessage :message="$root.message" :error="$root.error"/>
      </slot>

        <slot name="name" v-if="$root.isEnabledRegisterFIO && !$root.isEnabledRegisterFIOSplit">
          <BXmakerAuthuserphoneInputFIO
              :title="$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_REG_FORM_FIO"
              :value="$root.fio"
              @onInput="onInputFIO"
              @onEnter="onEnterFIO"
              name="FIO"
              :dadata="$root.registerFIODadata"
              ref="fio"
          />
        </slot>

   
        
        <slot name="lastName" v-if="$root.isEnabledRegisterFIOSplit && $root.isEnabledRegisterLastName">
          <BXmakerAuthuserphoneInput
              :title="$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_REG_FORM_LAST_NAME"
              :value="$root.lastName"
              @onInput="onInputLastName"
              @onEnter="onEnterLastName"
              name="LAST_NAME"
              ref="lastName"
          />
        </slot>

        <slot name="firstName" v-if="$root.isEnabledRegisterFIOSplit && $root.isEnabledRegisterFirstName">
          <BXmakerAuthuserphoneInput
              :title="$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_REG_FORM_FIRST_NAME"
              :value="$root.firstName"
              @onInput="onInputFirstName"
              @onEnter="onEnterFirstName"
              name="FIRST_NAME"
              ref="firstName"
          />
        </slot>
        
        <slot name="secondName" v-if="$root.isEnabledRegisterFIOSplit && $root.isEnabledRegisterSecondName">
          <BXmakerAuthuserphoneInput
              :title="$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_REG_FORM_SECOND_NAME"
              :value="$root.secondName"
              @onInput="onInputSecondName"
              @onEnter="onEnterSecondName"
              name="SECOND_NAME"
              ref="secondName"
          />
        </slot>
               
        
        
        <slot name="birthday" v-if="$root.isEnabledRegisterBirthday">
        <BXmakerAuthuserphoneInput
            :title="$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_REG_FORM_BIRTHDAY"
            :value="$root.birthday"
            @onInput="onInputBirthday"
            @onEnter="onEnterBirthday"
            name="BIRTHDAY"
            ref="birthday"
            :mask="birthdayMask"
        />
      </slot>


      <slot name="phone">
        <BXmakerAuthuserphoneInputPhone 
            v-if="$root.isEnabledPhoneMaskTypeBitrix"
                                        :title="$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_REG_FORM_PHONE"
                                        :value="$root.phone"
                                        @onChange="onChangePhone"
                                        @onEnter="onEnterPhone"
                                        name="PHONE"
                                        :mask="$root.phoneMaskParams"
                                        ref="phone"
        />

        <BXmakerAuthuserphoneInput v-else
                                   :title="$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_REG_FORM_PHONE"
                                   :value="$root.phone"
                                   @onInput="$root.setPhone"
                                   @onEnter="onEnterPhone"
                                   name="PHONE"
                                   ref="phone"
                                   :mask="$root.phoneMaskParams"
                                   type="tel"
        />
      </slot>
      <slot name="login" v-if="$root.isEnabledRegisterLogin">
        <BXmakerAuthuserphoneInput
            :title="$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_REG_FORM_LOGIN"
            :value="$root.login"
            @onInput="$root.setLogin"
            @onEnter="onEnterLogin"
            name="LOGIN"
            ref="login"
        />
      </slot>
      <slot name="email" v-if="$root.isEnabledRegisterEmail">
        <BXmakerAuthuserphoneInput
            :title="$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_REG_FORM_EMAIL"
            :value="$root.email"
            @onInput="$root.setEmail"
            @onEnter="onEnterEmail"
            name="EMAIL"
            ref="email"
        />
      </slot>

      <slot name="pass" v-if="$root.isEnabledRegisterPassword">
        <BXmakerAuthuserphoneInputPassword
            :title="$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_REG_FORM_PASSWORD"
            :value="$root.password"
            @onInput="$root.setPassword"
            @onEnter="onEnterPassword"
            ref="password"
            name="PASSWORD"
        />
      </slot>


      <slot name="captcha">
        <BXmakerAuthuserphoneCaptcha
            :code="$root.captchaCode"
            :src="$root.captchaSrc"
            :length="$root.captchaLength"
            :loader="$root.captchaLoader"
            @onInput="$root.setCaptchaCode"
            @onComplete="onClickConfirm"
            @onRefresh="$root.refreshCaptcha"
        />
      </slot>
        

        <slot name="adsAgreement" v-if="$root.isEnabledRequestAdsAgreement">
          <BXmakerAuthuserphoneCheckbox
              :label="$root.requestAdsAgreementLabel"
              :checked="$root.isAdsAgreementReceived"
              name="adsAgreement"
              @onChange="onChangeAdsAgreement"
              ref="adsAgreement"
          />
        </slot>
        

      <slot name="consent" v-if="$root.isEnabledRequestConsent">
        <BXmakerAuthuserphoneConsent
            :button="$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_REG_FORM_BUTTON"
            :text="$root.consentText"
            :isReceived="$root.isConsentReceived"
            @onAgree="onConsentAgree"
            @onDisagree="$root.consentDisagree"
            ref="consent"
        />
      </slot>

      <slot name="request">
        <BXmakerAuthuserphoneButton
            :title="$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_REG_FORM_BUTTON"
            :loader="$root.startLoader"
            @onClick="onClickConfirm"
        />
      </slot>


      </div>
    `,
});